/**
 * Dineo Design System - Typography
 *
 * Display headings: Playfair Display Variable (serif) — elegant gastro feel
 * Body text: Raleway Variable (sans-serif) — warm, boutique readability
 * Code / mono: JetBrains Mono (monospace)
 *
 * Reference: docs/ci-colors.md
 */

const fontFamilyDisplay = '"Playfair Display Variable", Georgia, serif';
const fontFamilyBody = '"Raleway Variable", system-ui, sans-serif';
const fontFamilyMono = '"JetBrains Mono", "Courier New", monospace';

export const typography = {
  fontFamily: fontFamilyBody,

  // -- Custom display variants --
  display1: {
    fontFamily: fontFamilyDisplay,
    fontSize: '3rem', // 48px
    lineHeight: 1.1,
    fontWeight: 900,
    letterSpacing: '-0.02em',
  },
  display2: {
    fontFamily: fontFamilyDisplay,
    fontSize: '2.5rem', // 40px
    lineHeight: 1.15,
    fontWeight: 700,
    letterSpacing: '-0.015em',
  },

  // -- Standard MUI heading variants --
  h1: {
    fontFamily: fontFamilyDisplay,
    fontSize: '2rem', // 32px
    lineHeight: 1.2,
    fontWeight: 700,
    letterSpacing: '-0.01em',
  },
  h2: {
    fontFamily: fontFamilyDisplay,
    fontSize: '1.75rem', // 28px
    lineHeight: 1.25,
    fontWeight: 600,
    letterSpacing: '-0.005em',
  },
  h3: {
    fontFamily: fontFamilyBody,
    fontSize: '1.5rem', // 24px
    lineHeight: 1.3,
    fontWeight: 700,
  },
  h4: {
    fontFamily: fontFamilyBody,
    fontSize: '1.25rem', // 20px
    lineHeight: 1.35,
    fontWeight: 600,
  },
  h5: {
    fontSize: '1.125rem', // 18px
    lineHeight: 1.4,
    fontWeight: 600,
    letterSpacing: '0.005em',
  },
  h6: {
    fontSize: '1rem', // 16px
    lineHeight: 1.4,
    fontWeight: 600,
    letterSpacing: '0.01em',
  },

  // -- Body variants --
  body1: {
    fontSize: '1rem', // 16px
    lineHeight: 1.5,
    fontWeight: 400,
  },
  body2: {
    fontSize: '0.875rem', // 14px
    lineHeight: 1.5,
    fontWeight: 400,
    letterSpacing: '0.005em',
  },

  // -- Subtitle variants --
  subtitle1: {
    fontSize: '1rem', // 16px
    lineHeight: 1.4,
    fontWeight: 500,
    letterSpacing: '0.005em',
  },
  subtitle2: {
    fontSize: '0.875rem', // 14px
    lineHeight: 1.4,
    fontWeight: 500,
    letterSpacing: '0.01em',
  },

  // -- Utility variants --
  button: {
    fontSize: '0.875rem', // 14px
    lineHeight: 1.2,
    fontWeight: 600,
    letterSpacing: '0.02em',
    textTransform: 'none',
  },
  caption: {
    fontSize: '0.75rem', // 12px
    lineHeight: 1.4,
    fontWeight: 400,
    letterSpacing: '0.02em',
  },
  overline: {
    fontSize: '0.6875rem', // 11px
    lineHeight: 1.5,
    fontWeight: 600,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
  },

  // -- Custom mono variant --
  mono: {
    fontFamily: fontFamilyMono,
    fontSize: '0.875rem', // 14px
    lineHeight: 1.4,
    fontWeight: 500,
  },
};
